import {
    FETCH_ALL_GROUPS_START, FETCH_ALL_GROUPS_ERROR, FETCH_ALL_GROUPS_SUCCESS, RESET_GROUPS,
    // FETCH_UNASSIGNED_GROUPS_ERROR, FETCH_UNASSIGNED_GROUPS_START, FETCH_UNASSIGNED_GROUPS_SUCCESS, RESET_UNASSIGNED_GROUPS, 
    FETCH_ALL_GROUP_MEMBERS_START, FETCH_ALL_GROUP_MEMBERS_ERROR, FETCH_ALL_GROUP_MEMBERS_SUCCESS, ADD_UPDATE_GROUP_SUCCESS, FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS, FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR, ADD_GROUP_MEMBER_SUCCESS, REMOVE_GROUP_MEMBER_SUCCESS, SHOW_UNASSIGNED_GROUP_MEMEBERS_MODAL, HIDE_UNASSIGNED_GROUP_MEMEBERS_MODAL, SET_ALL_GROUPS_PAGINATION
} from "../../actions/admin/groupsActions";
import _ from 'lodash';

const INIT_STATE = {
    error: '',
    loading: false,
    message: '',
    ris: [],
    groups: [],
    groupMembers: [],
    unassignedGroupMembers: [],
    unassinedgrouMemberspModal: false,
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
}

const groupsReducer = (state = INIT_STATE, action) => {
    let newState;
    switch (action.type) {
        // case FETCH_UNASSIGNED_GROUPS_START: {
        //     return { ...state, loading: true };
        // }
        // case FETCH_UNASSIGNED_GROUPS_SUCCESS: {
        //     const groups = action.groups.length > 0 ? [...action.groups] : [];
        //     return { ...state, loading: false, groups };
        // }
        // case FETCH_UNASSIGNED_GROUPS_ERROR: {
        //     return { ...state, loading: false };
        // }
        // case RESET_UNASSIGNED_GROUPS: {
        //     return { ...INIT_STATE }
        // }

        case FETCH_ALL_GROUPS_START: {
            return { ...state, loading: true };
        }
        case FETCH_ALL_GROUPS_SUCCESS: {
            const groups = action.groups.length > 0 ? [...action.groups] : [];
            return { ...state, loading: false, groups };
        }
        case FETCH_ALL_GROUPS_ERROR: {
            return { ...state, loading: false };
        }
        case SET_ALL_GROUPS_PAGINATION: {
                    return { ...state, error: '', message: '', pagination: { ...action.pagination } };
        }
        case RESET_GROUPS: {
            return { ...INIT_STATE }
        }

        case FETCH_ALL_GROUP_MEMBERS_START: {
            return { ...state, loading: true };
        }
        case FETCH_ALL_GROUP_MEMBERS_SUCCESS: {
            const groupMembers = action.groupMembers.length > 0 ? [...action.groupMembers] : [];
            return { ...state, loading: false, groupMembers };
        }
        case FETCH_ALL_GROUP_MEMBERS_ERROR: {
            return { ...state, loading: false };
        }
        case ADD_UPDATE_GROUP_SUCCESS: {
            newState = _.cloneDeep(state);
            let index = state.groups.findIndex(group => group.groupId === action.group.groupId);
            if (index > -1) {
                newState.groups[index] = { ...action.group }
            } else {
                newState.groups.push(action.group)
            }
            return { ...newState, loading: false };
        }
        case FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS: {
            return { ...state, unassignedGroupMembers: [...action.unassignedGroupMembers] };
        }
        case FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR: {
            return { ...state, unassignedGroupMembers: [] };
        }
        case ADD_GROUP_MEMBER_SUCCESS: {
            let groupMembers = [...state.groupMembers]
            groupMembers.push(action.groupMember);
            let unassignedGroupMembers = state.unassignedGroupMembers;
            unassignedGroupMembers = unassignedGroupMembers.filter(unassignedgroupMember => unassignedgroupMember.userId !== action.groupMember.userId)

            return { ...state, 'groupMembers': [...groupMembers], unassinedgrouMemberspModal: false, 'unassignedGroupMembers': [...unassignedGroupMembers] };
        }
        case REMOVE_GROUP_MEMBER_SUCCESS: {
            let modifiedGroupMembers = state.groupMembers.filter(groupMember => groupMember.userId !== action.payload.userId);
            return { ...state, groupMembers: [...modifiedGroupMembers], };
        }

        case SHOW_UNASSIGNED_GROUP_MEMEBERS_MODAL: {
            return { ...state, unassinedgrouMemberspModal: true }
        }
        case HIDE_UNASSIGNED_GROUP_MEMEBERS_MODAL: {
            return { ...state, unassinedgrouMemberspModal: false }
        }

        default:
            return state;
    }
}

export default groupsReducer;
